export default {"src":"/_next/static/media/Qrcode.a2eac080.svg","height":201,"width":201,"blurWidth":0,"blurHeight":0};